/*
 * The mega menu panels are rendered once, inside the desktop menu. The mobile drawer only carries
 * an empty slot per panel ([data-kw-mega-slot="<block id>"]), and this moves the desktop panel
 * ([data-kw-mega-panel="<block id>"]) into it when a drawer category is opened. When the viewport
 * crosses into the desktop range the panels go back home, so the desktop menu is never empty.
 */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 990px)');
  var homes = new Map();

  function panelFor(id) {
    return document.querySelector('[data-kw-mega-panel="' + id + '"]');
  }

  function fill(slot) {
    if (!slot || slot.firstElementChild) return;
    var panel = panelFor(slot.getAttribute('data-kw-mega-slot'));
    if (!panel) return;
    if (!homes.has(panel)) homes.set(panel, { parent: panel.parentNode, next: panel.nextSibling });
    slot.appendChild(panel);
  }

  // Only the slot that belongs to this details, not one in a nested or parent level.
  function slotOf(details) {
    var slots = details.querySelectorAll("[data-kw-mega-slot]");
    for (var i = 0; i < slots.length; i++) if (slots[i].closest("details") === details) return slots[i];
    return null;
  }

  function restoreAll() {
    homes.forEach(function (home, panel) {
      if (panel.parentNode === home.parent) return;
      var next = home.next && home.next.parentNode === home.parent ? home.next : null;
      home.parent.insertBefore(panel, next);
    });
  }

  // Capture phase, so the panel is in place before the drawer's own handler measures or animates.
  document.addEventListener('click', function (event) {
    if (desktop.matches) return;
    var summary = event.target.closest && event.target.closest('header-drawer summary');
    if (!summary) return;
    fill(slotOf(summary.parentElement));
  }, true);

  // Any other route that opens a drawer category (keyboard, script) still gets its panel.
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (desktop.matches || !details.open || !details.closest || !details.closest('header-drawer')) return;
    fill(slotOf(details));
  }, true);

  var onChange = function () { if (desktop.matches) restoreAll(); };
  if (desktop.addEventListener) desktop.addEventListener('change', onChange);
  else if (desktop.addListener) desktop.addListener(onChange);
})();
